exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2yLvu7v1hsZAGVirPtMN5{margin:0 0 20px 0}._3DxdQkh-1fewaX90b5N_v1{text-align:center}\n", ""]);

// Exports
exports.locals = {
	"lessMargin": "_2yLvu7v1hsZAGVirPtMN5",
	"successMessage": "_3DxdQkh-1fewaX90b5N_v1"
};